import { Block, Flex } from '@aloft/toolkit-sui';

export const RegressionModalGraphSection = () => (
  <Flex gap="1rem">
    <Block flex={1} height="160px" backgroundColor="surface2" borderRadius="4px" />
    <Block flex={1} height="160px" backgroundColor="surface2" borderRadius="4px" />
  </Flex>
);
